const OrganizationKeys = {
  all: ['Organizations'] as const,
  entireList: () => [...OrganizationKeys.all, 'entireList'] as const,
  lists: () => [...OrganizationKeys.all, 'list'] as const,
  list: (queryParams: string) => [...OrganizationKeys.lists(), { queryParams }] as const,
  details: () => [...OrganizationKeys.all, 'detail'] as const,
  detail: (id: string) => [...OrganizationKeys.details(), id] as const,
  hasLicense: () => [...OrganizationKeys.all, 'hasLicense'] as const,
  license: (orgId: string, license: string) =>
    [...OrganizationKeys.hasLicense(), orgId, license] as const,
  orgLicensesCollections: () => [...OrganizationKeys.all, 'orgLicensesCollections'] as const,
  orgLicensesCollection: (orgId: string) =>
    [...OrganizationKeys.orgLicensesCollections(), orgId] as const,
  availableLicenses: () => [...OrganizationKeys.all, 'availableLicenses'] as const,
};

export { OrganizationKeys };
